import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axiosInstance from '../../utils/axios';
import Iconify from '../../reuseable-components/iconify/Iconify';

export default function QuickbooksConnect() {
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [testingConnection, setTestingConnection] = useState(false);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get("/quickbooks/LastUpdated")
      .then(res => setLastUpdated(res.data))
      .catch(() => enqueueSnackbar('Check last update failed', { variant: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  const connectToQuickbooks = () => {
    axiosInstance.get("/quickbooks/InitiateAuth")
      .then(res => window.open(res.data, '_blank'))
      .catch(() => enqueueSnackbar('Quickbooks connection failed', { variant: 'error' }))
  }

  const testConnection = () => {
    setTestingConnection(true);
    axiosInstance.get("/quickbooks/TestConnection")
      .then(res => {
        if (res.data) enqueueSnackbar('Quickbooks connected', { variant: 'success' })
        else enqueueSnackbar('Quickbooks connection failed', { variant: 'error' })
      })
      .catch(() => enqueueSnackbar('Quickbooks connection failed', { variant: 'error' }))
      .finally(() => setTestingConnection(false));
  }

  return (<>
    <Helmet>
      <title>Quickbooks | NHIDirect</title>
    </Helmet>

    <Box sx={{ height: "calc(100% - 55px)", mt: 2 }}>
      {!loading ? <Stack spacing={2}>
        <Box>
          <Typography variant="subtitle1">
            <Typography>Last Updated</Typography>
            <Typography>{lastUpdated ? new Date(lastUpdated).toLocaleTimeString() : ""}</Typography>
          </Typography>
        </Box>
        <Box>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={connectToQuickbooks} color="primary" size="small">
            <Typography>Connect To Quickbooks</Typography>
          </Button>
        </Box>
        <Box>
          <LoadingButton loading={testingConnection} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={testConnection} color="primary" size="small">
            <Typography>Test Connection</Typography>
          </LoadingButton>
        </Box>
      </Stack> : <Box sx={{ display: "flex", justifyContent: "center", m: 3 }}><CircularProgress /></Box>}
    </Box>
  </>);
}
